var exports = {
  "k": "container__0AUmrS",
};

module.exports = exports;
